var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.671 1.768h-1.705L13.154.25a1.025 1.025 0 0 0-1.32 0l-1.812 1.518H8.315c-1.03 0-1.864.846-1.864 1.89v1.1L4.17 6.675a.21.21 0 0 0-.04.054v.015a.212.212 0 0 0-.02.084v8.083c0 1.044.836 1.89 1.865 1.89H19.03c1.03 0 1.864-.846 1.864-1.89V6.838a.212.212 0 0 0-.019-.084v-.015a.21.21 0 0 0-.041-.055L18.556 4.77V3.66c0-.506-.199-.99-.553-1.345a1.851 1.851 0 0 0-1.332-.546zM12.097.573a.615.615 0 0 1 .792 0l1.427 1.195H10.67L12.097.573zM8.315 2.188h8.356c.801 0 1.45.658 1.45 1.47v4.86l-5.257 3.973a.615.615 0 0 1-.744 0L6.865 8.518v-4.86c0-.812.65-1.47 1.45-1.47zM6.45 5.305v2.898L4.63 6.827l1.82-1.522zM19.03 16.38H5.955c-.8 0-1.45-.658-1.45-1.47V7.258l1.98 1.497a.207.207 0 0 0 .117.088l5.27 3.984c.368.28.874.28 1.243 0l5.27-3.99a.207.207 0 0 0 .115-.088l1.983-1.498v7.659c0 .39-.153.764-.426 1.04a1.44 1.44 0 0 1-1.026.43zm1.321-9.542l-1.818 1.375V5.305l1.818 1.533z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.d19390588192946ab200ffe3d12417f6.svg";
export { ForwardRef as ReactComponent };